import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
@Component({
    selector: "app-marketplace-logo",
    template: `
		<div [ngStyle]="styles">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 457 271"
				style="max-width: 100%; max-height: 100%;"
			>
				<path fill="url(#a)" d="M74.9 270.86 170.11 0h-74.9L0 270.86h74.9Z" />
				<mask
					id="b"
					width="171"
					height="271"
					x="0"
					y="0"
					maskUnits="userSpaceOnUse"
					style="mask-type:luminance"
				>
					<path fill="#fff" d="M74.9 270.86 170.11 0h-74.9L0 270.86h74.9Z" />
				</mask>
				<g filter="url(#c)" mask="url(#b)">
					<path fill="#fff" d="M170.11 0H95.33l37.39 106.37L170.11 0Z" />
				</g>
				<path fill="url(#d)" d="M265.57 270.86 360.78 0h-74.9l-95.21 270.86h74.9Z" />
				<mask
					id="e"
					width="171"
					height="271"
					x="190"
					y="0"
					maskUnits="userSpaceOnUse"
					style="mask-type:luminance"
				>
					<path fill="#fff" d="m285.88 0-95.21 270.86h74.9L360.78 0h-74.9Z" />
				</mask>
				<g filter="url(#f)" mask="url(#e)">
					<path fill="#fff" d="M190.67 270.86h74.78l-37.39-106.37-37.39 106.37Z" />
				</g>
				<path fill="url(#g)" d="M190.54 270.86 95.33 0h74.9l95.21 270.86h-74.9Z" />
				<mask
					id="h"
					width="171"
					height="271"
					x="190"
					y="0"
					maskUnits="userSpaceOnUse"
					style="mask-type:luminance"
				>
					<path fill="#fff" d="M265.57 270.86 360.78 0h-74.9l-95.21 270.86h74.9Z" />
				</mask>
				<g filter="url(#i)" mask="url(#h)">
					<path fill="#fff" d="M360.78 0H286l37.39 106.37L360.78 0Z" />
				</g>
				<path fill="url(#j)" d="M381.15 270.86 285.93 0h74.9l95.22 270.86h-74.9Z" />
				<defs>
					<linearGradient
						id="a"
						x1="14.88"
						x2="174.69"
						y1="256.98"
						y2="-19.82"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#204684" />
						<stop offset="1" stop-color="#345FAF" />
					</linearGradient>
					<linearGradient
						id="d"
						x1="195.82"
						x2="355.63"
						y1="273.83"
						y2="-2.97"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#FF931E" />
						<stop offset="1" stop-color="#F97C00" />
					</linearGradient>
					<linearGradient
						id="g"
						x1="124.28"
						x2="236.49"
						y1="232.6"
						y2="38.26"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#1886C9" />
						<stop offset="1" stop-color="#3FA9F5" />
					</linearGradient>
					<linearGradient
						id="j"
						x1="291.08"
						x2="450.9"
						y1="-2.97"
						y2="273.83"
						gradientUnits="userSpaceOnUse"
					>
						<stop stop-color="#204684" />
						<stop offset="1" stop-color="#345FAF" />
					</linearGradient>
					<filter
						id="c"
						width="95.22"
						height="126.81"
						x="83.07"
						y="-7.16"
						color-interpolation-filters="sRGB"
						filterUnits="userSpaceOnUse"
					>
						<feFlood flood-opacity="0" result="BackgroundImageFix" />
						<feColorMatrix
							in="SourceAlpha"
							result="hardAlpha"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						/>
						<feOffset dx="-2.04" dy="3.06" />
						<feGaussianBlur stdDeviation="5.11" />
						<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
						<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1_157" />
						<feBlend in="SourceGraphic" in2="effect1_dropShadow_1_157" result="shape" />
					</filter>
					<filter
						id="f"
						width="95.22"
						height="126.81"
						x="178.41"
						y="157.33"
						color-interpolation-filters="sRGB"
						filterUnits="userSpaceOnUse"
					>
						<feFlood flood-opacity="0" result="BackgroundImageFix" />
						<feColorMatrix
							in="SourceAlpha"
							result="hardAlpha"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						/>
						<feOffset dx="-2.04" dy="3.06" />
						<feGaussianBlur stdDeviation="5.11" />
						<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
						<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1_157" />
						<feBlend in="SourceGraphic" in2="effect1_dropShadow_1_157" result="shape" />
					</filter>
					<filter
						id="i"
						width="95.22"
						height="126.81"
						x="273.74"
						y="-7.16"
						color-interpolation-filters="sRGB"
						filterUnits="userSpaceOnUse"
					>
						<feFlood flood-opacity="0" result="BackgroundImageFix" />
						<feColorMatrix
							in="SourceAlpha"
							result="hardAlpha"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						/>
						<feOffset dx="-2.04" dy="3.06" />
						<feGaussianBlur stdDeviation="5.11" />
						<feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
						<feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1_157" />
						<feBlend in="SourceGraphic" in2="effect1_dropShadow_1_157" result="shape" />
					</filter>
				</defs>
			</svg>
		</div>
	`,
    imports: [CommonModule]
})
export class MarketplaceLogoComponent {
	@Input() width?: string;
	@Input() height?: string;
	@Input() maxWidth?: string = "10rem";
	@Input() maxHeight?: string = "10rem";

	get styles(): { [key: string]: string | undefined } {
		return {
			// eslint-disable-next-line @typescript-eslint/naming-convention
			"max-width": this.maxWidth,
			// eslint-disable-next-line @typescript-eslint/naming-convention
			"max-height": this.maxHeight,
			width: this.width,
			height: this.height,
			display: "flex",
			"align-items": "center",
			"justify-content": "center"
		};
	}
}
